import LoginPage from './LoginPage';
import LogoutPage from './LogoutPage';

export const auth = {
  routes: [
    {
      component: LoginPage,
      path: '/login',
      exact: true,
    },
    {
      component: LogoutPage,
      path: '/logout',
      exact: true,
    },
  ],
};
